var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-500"},[_c('h1',[_vm._v("error 500: server err")]),_vm._v(" "),_c('p')])}]

export { render, staticRenderFns }